import { addSasTokenToResponse } from 'app/utils/blobStorageHelpers';
import { BlobStorageContainer, Entity } from 'app/utils/constants';
import { ApiRequestService } from 'app/services/api-service';

export async function uploadRequestEditorImage(file: File, blobName: string) {
    const client = ApiRequestService.createInstance();
    const uploadResponse = await client.uploadFileToBlobStorageAsync(file, blobName);
    const url = uploadResponse.data.fullBlobUri?.toString();
    if (!url) {
        throw new Error('Image upload did not return a blob URL.');
    }

    return addSasTokenToResponse(
        Entity.REQUEST,
        BlobStorageContainer.PORTAL_ATTACHMENTS,
        { result: [{ url }] },
    );
}
